export const ErrorIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 4.49L19.03 17.5H3.97L11.5 4.49ZM11.5 0.5L0.5 19.5H22.5L11.5 0.5ZM12.5 14.5H10.5V16.5H12.5V14.5ZM12.5 8.5H10.5V12.5H12.5V8.5Z"
      fill="white"
    />
  </svg>
);

export const SuccessIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18ZM15.09 5.58L8.5 12.17L5.91 9.59L4.5 11L8.5 15L16.5 7L15.09 5.58Z"
      fill="white"
    />
  </svg>
);